/**
 * Utility for parsing and validating URLs from share intents and deep links.
 */

const URL_REGEX = /(https?:\/\/[^\s]+)/g

export function extractTargetUrl(url: string | null | undefined): string | null {
    if (!url) return null
    
    let targetUrl = ''

    const matches = url.match(URL_REGEX)
    if (matches && matches[0]) {
        targetUrl = matches[0]
    } else if (url.startsWith('shuvo://share-save?url=')) {
        // Extract encoded URL from iOS share extension scheme
        try {
            const searchPart = url.split('?')[1]
            const params = new URLSearchParams(searchPart)
            targetUrl = params.get('url') || ''
        } catch (err) {
            console.error('Failed to parse iOS share scheme URL:', err)
        }
    } else if (url.startsWith('shuvo://') || url.includes('shuvo.pro')) {
        targetUrl = url
    }

    if (!targetUrl) return null

    // EXCLUSION: If the URL is an internal Shuvo link (collection preview, invite, auth),
    // we should NOT save it as a pick. This is handled by the Deep Link router.
    const isInternal = targetUrl.startsWith('shuvo://') ||
                     targetUrl.includes('shuvo.pro') || 
                     targetUrl.includes('shuvo.app') || 
                     targetUrl.includes('google-cloud-run') || 
                     targetUrl.includes('us-central1.run.app') ||
                     targetUrl.includes('/s/') ||
                     targetUrl.includes('/invite/') ||
                     targetUrl.includes('/auth/')

    if (isInternal) {
        return null
    }

    return targetUrl
}
